import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { __ } from '@wordpress/i18n';
import { Button, IconButton, Placeholder } from '@wordpress/components';

function InnerBlocksTemplatePicker(_ref) {
  var options = _ref.options,
      onSelect = _ref.onSelect,
      allowSkip = _ref.allowSkip;
  var classes = classnames('block-editor-inner-blocks__template-picker', {
    'has-many-options': options.length > 4
  });
  var instructions = allowSkip ? __('Select a layout to start with, or make one yourself.') : __('Select a layout to start with.');
  return createElement(Placeholder, {
    icon: "layout",
    label: __('Choose Layout'),
    instructions: instructions,
    className: classes
  }, createElement("ul", {
    className: "block-editor-inner-blocks__template-picker-options",
    role: "list"
  }, options.map(function (templateOption, index) {
    return createElement("li", {
      key: index
    }, createElement(IconButton, {
      isLarge: true,
      icon: templateOption.icon,
      onClick: function onClick() {
        return onSelect(templateOption.template);
      },
      className: "block-editor-inner-blocks__template-picker-option",
      label: templateOption.title
    }));
  })), allowSkip && createElement("div", {
    className: "block-editor-inner-blocks__template-picker-skip"
  }, createElement(Button, {
    isLink: true,
    onClick: function onClick() {
      return onSelect(undefined);
    }
  }, __('Skip'))));
}

export default InnerBlocksTemplatePicker;
//# sourceMappingURL=template-picker.js.map